import React, { useEffect } from 'react';
import { NeonErrorPageContent } from '@ps-refarch-ux/neon';
import { loadStylesheet } from '@ps-refarch-ux/mfe-utils';
import { PageNotFoundStatusCode } from '../common/constants/constants';

export function PageNotFoundComponent(): React.JSX.Element {

  useEffect(() => {
    const { neonVersion } = require('../../package.json');
    // We need to load the neon style css for page not found component.
    loadStylesheet(`https://assets.powerschool.com/neon/${neonVersion}/css/neon-styles.css`);
  }, []);

  return (
    <>
      <main className="neon-4_6_0-app-layout-main-content">
        <div className="neon-4_6_0-error-page">
          <div className="neon-error-page-wrapper">
            <div className="neon-error-page-column">
              <NeonErrorPageContent
                dataHeading="Page not found."
                dataErrorCode={PageNotFoundStatusCode}
                dataShowErrorCode="true"
              >
              </NeonErrorPageContent>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}